export default __webpack_public_path__ + "static/hookah-presentation-cc0ce58296b33a2b6c50ed7cc2b5e563.png";